import React, { useEffect, useState } from 'react';
import { Content, Title, Row, Col, InputFormTable } from 'components';
import { Select, Input, Button, Tag, Empty } from 'antd';
import Formatter from 'utils/Formatter';

const ManagerRegisterPresenter = ({
  auth,
  registrationData,
  data,
  isChecked,
  onSubmit,
  onChange,
  onDuplication,
  defaultShop,
}) => {
  const [privilegeList, setPrivilegeList] = useState(['X', 'X', 'X', 'X']); // 초기 권한 값 설정
  const [allPrivilegesSelected, setAllPrivilegesSelected] = useState(false); // 전체 권한 선택 상태 관리

  useEffect(() => {
    const privilegeString = privilegeList.join('');
    onChange('admin_privilege', privilegeString);

    // 모든 권한이 선택되었는지 확인하여 전체 권한 상태 업데이트
    setAllPrivilegesSelected(
      privilegeList.every((privilege) => privilege !== 'X')
    );
    // eslint-disable-next-line
  }, [privilegeList]);

  // 특정 권한 추가/삭제 로직
  const handleTogglePrivilege = (privilege) => {
    const privilegeIndex = getPrivilegeIndex(privilege);
    if (privilegeIndex !== -1) {
      setPrivilegeList((prev) => {
        const updatedPrivileges = [...prev];
        updatedPrivileges[privilegeIndex] =
          updatedPrivileges[privilegeIndex] === privilege ? 'X' : privilege;
        return updatedPrivileges;
      });
    }
  };

  // 전체 권한 추가/삭제
  const handleToggleAllPrivileges = () => {
    if (allPrivilegesSelected) {
      // 모든 권한 해제
      setPrivilegeList(['X', 'X', 'X', 'X']);
    } else {
      // 모든 권한 추가
      setPrivilegeList(['C', 'R', 'U', 'D']);
    }
  };

  // 권한에 따른 인덱스 매핑
  const getPrivilegeIndex = (privilege) => {
    const privilegeMap = { C: 0, R: 1, U: 2, D: 3 };
    return privilegeMap[privilege] ?? -1;
  };

  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    subTitle: {
      fontSize: 17,
      fontWeight: 500,
      lineHeight: '141%',
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
  };

  const form = [
    ...(defaultShop
      ? []
      : [
          {
            label: '관리자 타입',
            required: true,
            form: [
              {
                input: (
                  <Select
                    size="large"
                    placeholder="관리자 타입을 선택하세요."
                    options={[
                      { label: '총 관리자', value: 'ADMIN' },
                      { label: '쇼핑몰 관리자', value: 'SHOP_ADMIN' },
                      { label: '매장 관리자', value: 'STORE_ADMIN' },
                    ]}
                    value={registrationData.type}
                    onChange={(value) =>
                      onChange(
                        'type',
                        value,
                        onChange('shop_information_id', null)
                      )
                    }
                  />
                ),
              },
            ],
          },
          {
            label: '관리 매장/쇼핑몰',
            required: true,
            form: [
              {
                input: (
                  <Select
                    size="large"
                    placeholder="매장/쇼핑몰을 선택하세요."
                    options={data
                      ?.filter(
                        (item) =>
                          item?.type ===
                            (registrationData?.type === 'ADMIN'
                              ? 'ALL'
                              : registrationData?.type?.split('_')?.[0]) ||
                          (item?.type === 'ALL' &&
                            registrationData?.type?.split('_')?.[0] === 'SHOP')
                      )
                      ?.map((shop) => ({
                        label: shop.shop_information_name, // 매장/쇼핑몰 이름 표시
                        value: shop.shop_information_id, // 매장/쇼핑몰 ID 값
                      }))}
                    value={
                      registrationData.type === 'ADMIN'
                        ? 1
                        : registrationData.shop_information_id
                    }
                    onChange={(value) => onChange('shop_information_id', value)}
                    disabled={registrationData.type === 'ADMIN'} // 'ADMIN'일 때 비활성화
                  />
                ),
              },
            ],
          },
        ]),

    {
      label: '관리자 등급',
      required: true,
      form: [
        {
          input: (
            <Select
              size="large"
              placeholder="등급을 선택하세요."
              options={[
                { label: '1', value: 1 },
                { label: '2', value: 2 },
                { label: '3', value: 3 },
              ]}
              value={registrationData.admin_level}
              onChange={(value) => onChange('admin_level', value)}
            />
          ),
        },
      ],
    },
    {
      label: '권한 등급',
      required: true,
      form: [
        {
          input: (
            <div>
              {/* 전체 권한 선택 버튼 */}
              <Button
                size="large"
                onClick={handleToggleAllPrivileges}
                style={{
                  margin: '0 4px',
                  background: allPrivilegesSelected ? '#1677ff' : '#f5f5f5',
                  color: allPrivilegesSelected ? '#ffffff' : '#000000',
                }}
              >
                {allPrivilegesSelected ? '전체 해제' : '전체 선택'}
              </Button>

              {/* 권한 개별 선택 버튼들 */}
              <Button
                size="large"
                onClick={() => handleTogglePrivilege('C')}
                style={{
                  margin: '0 4px',
                  background: privilegeList[0] === 'C' ? '#1677ff' : '#f5f5f5',
                  color: privilegeList[0] === 'C' ? '#ffffff' : '#000000',
                }}
              >
                등록 (C)
              </Button>
              <Button
                size="large"
                onClick={() => handleTogglePrivilege('R')}
                style={{
                  margin: '0 4px',
                  background: privilegeList[1] === 'R' ? '#1677ff' : '#f5f5f5',
                  color: privilegeList[1] === 'R' ? '#ffffff' : '#000000',
                }}
              >
                읽기 (R)
              </Button>
              <Button
                size="large"
                onClick={() => handleTogglePrivilege('U')}
                style={{
                  margin: '0 4px',
                  background: privilegeList[2] === 'U' ? '#1677ff' : '#f5f5f5',
                  color: privilegeList[2] === 'U' ? '#ffffff' : '#000000',
                }}
              >
                수정 (U)
              </Button>
              <Button
                size="large"
                onClick={() => handleTogglePrivilege('D')}
                style={{
                  margin: '0 4px',
                  background: privilegeList[3] === 'D' ? '#1677ff' : '#f5f5f5',
                  color: privilegeList[3] === 'D' ? '#ffffff' : '#000000',
                }}
              >
                삭제 (D)
              </Button>
            </div>
          ),
        },
        {
          input: (
            <div style={{ marginTop: 16 }}>
              {/* 선택된 권한 리스트 출력 */}
              {privilegeList.map(
                (privilege, index) =>
                  privilege !== 'X' && (
                    <Tag
                      key={index}
                      color="blue"
                      closable
                      onClose={() => handleTogglePrivilege(privilege)}
                      style={styles.tag}
                    >
                      {privilege}
                    </Tag>
                  )
              )}
            </div>
          ),
        },
      ],
    },
    {
      label: '관리자 명',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="이름을 입력하세요."
              value={registrationData.admin_name}
              onChange={(e) => onChange('admin_name', e.target.value)}
            />
          ),
        },
      ],
    },
    {
      label: '관리자 아이디',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="아이디를 입력하세요."
              value={registrationData?.admin_account}
              onChange={(e) => onChange('admin_account', e.target.value)}
              disabled={isChecked === 'SUCCESS'} // 중복확인 후 비활성화
            />
          ),
        },
        {
          input: (
            <Button size="large" onClick={() => onDuplication()}>
              중복확인
            </Button>
          ),
        },
      ],
    },
    {
      label: '직책',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="직책을 입력하세요."
              value={registrationData.admin_position}
              onChange={(e) => onChange('admin_position', e.target.value)}
            />
          ),
        },
      ],
    },
    {
      label: '이메일',
      required: true,
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="이메일을 입력하세요."
                value={registrationData.admin_email_prefix}
                onChange={(e) => onChange('admin_email_prefix', e.target.value)}
              />
              <p>@</p>
              <Input
                size="large"
                placeholder="naver.com"
                value={registrationData.admin_email_domain}
                onChange={(e) => onChange('admin_email_domain', e.target.value)}
              />
            </>
          ),
        },
        // { input: <Button size="large">중복확인</Button> },
        // { input: <Checkbox size="large">이메일 수신 동의</Checkbox> },
      ],
    },
    {
      label: '휴대폰번호',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="휴대폰번호를 '-'없이 입력하세요."
              value={registrationData.admin_phone}
              onChange={(e) =>
                onChange('admin_phone', Formatter.hyphen(e.target.value))
              }
            />
          ),
        },
        // { input: <Checkbox size="large">SMS 수신 동의</Checkbox> },
      ],
    },
  ];

  return auth[0] !== 'C' ? (
    <Empty
      style={{
        height: 500,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
      description={
        <>
          <Title align={'center'}>
            해당 화면에 접근할 수 있는 권한이 없습니다.
          </Title>
        </>
      }
    ></Empty>
  ) : (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          {
            <>
              <Title style={{ ...styles.title }}>관리자 등록</Title>

              {/* 기본정보 */}
              <Content
                maxWidth={'100%'}
                padding={20}
                borderRadius={4}
                style={{ marginBottom: 40 }}
              >
                <Title style={{ ...styles.subTitle }}>기본 정보</Title>
                <InputFormTable form={form} />
              </Content>
              {/* 기본정보 끝 */}

              {/* 버튼 */}
              <Content maxWidth={'100%'} backgroundColor={'none'}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    size="large"
                    style={{
                      ...styles.button,
                      background: 'var(--primary-color)',
                      color: '#FFFFFF',
                    }}
                    onClick={() => onSubmit('admin', 'CREATE')}
                  >
                    저장
                  </Button>
                  <Button size="large" style={{ ...styles.button }}>
                    취소
                  </Button>
                </div>
              </Content>
              {/* 버튼 끝 */}
            </>
          }
        </Col>
      </Row>
    </Content>
  );
};

export default ManagerRegisterPresenter;
